import { useLazyGetAllTagsQuery } from '../../../../../services/cellcast'
import { useGetTagsMutation } from '../../../../../services/cellcast.v3'
import { GetCurrentData } from '../../../../Utils/_helpers/GetCurrentData'
import { defaultRegion } from '../../../../../_metronic/helpers';
import { GetData } from '../AllContactsList/SubscriberSlice/SubscriberSlice'
import { useDispatch, useSelector } from 'react-redux'
import {
  getTagContactCount,
} from './TagSlice/TagsSlices'
import { stopLoading } from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import { getIsDefaultRegion } from '../../accounts/Overview/OverviewSlice/UserDetailsSlice';

type params = {
  page: number,
  size: number,
  search: string,
}

export function useListTag() {
  const dispatch = useDispatch()
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const tagsData = useSelector((state: any) => state?.tags?.tags?.data)
  const TagsCount = useSelector(getTagContactCount)

  const [fetchTagsDataRegion, { data: tagsDataRegion }] = useGetTagsMutation()

  const fetchTagsData = (params?: params) => {
    if (isDefaultRegion) {
      dispatch(GetData(params))
    } else {
      fetchTagsDataRegion({
        action: 'find_tag',
        data: {
          page: params?.page ?? 1,
          limit: params?.size ?? 10,
          search: params?.search ?? '',
          type: 'tag'
        }
      })
      dispatch(stopLoading())
    }
  }

  return {
    fetchTagsData,
    tagslist: isDefaultRegion ? tagsData : tagsDataRegion?.data,
    TagsCount: isDefaultRegion ? TagsCount : []
  }
}
